import { Camera, PenLine } from "lucide-react";
import { Link } from "@tanstack/react-router";

export function ReadingEntryTabs({ active }: { active: "manual" | "capture" }) {
  return (
    <nav className="reading-entry-tabs" aria-label="阅读生词录入方式">
      <Link
        className={active === "manual" ? "reading-entry-tab reading-entry-tab--active" : "reading-entry-tab"}
        to="/app/$subject/my-words"
        params={{ subject: "english" }}
        aria-current={active === "manual" ? "page" : undefined}
      >
        <PenLine />
        <span>手动录入</span>
      </Link>
      <Link
        className={active === "capture" ? "reading-entry-tab reading-entry-tab--active" : "reading-entry-tab"}
        to="/app/$subject/capture"
        params={{ subject: "english" }}
        aria-current={active === "capture" ? "page" : undefined}
      >
        <Camera />
        <span>拍照录入</span>
      </Link>
    </nav>
  );
}
